import {Component} from '@angular/core';
import {Order} from "@spartacus/order/root";
import {OrderConsignedEntriesComponent} from "@spartacus/order/components";

@Component({
    selector: 'app-gonvarri-order-consigned-entries',
    templateUrl: './gonvarri-order-consigned-entries.component.html',
    styleUrl: './gonvarri-order-consigned-entries.component.scss',
    standalone: false
})
export class GonvarriOrderConsignedEntriesComponent extends OrderConsignedEntriesComponent {

  getOrderCode(order: Order): string {
    return order.code as string;
  }

  getDateHours(date: Date | undefined): string {
    const curDate = new Date(date as Date);
    return curDate.getHours() + ':' + curDate.getMinutes();
  }

}
